import { bffServiceClient } from 'packages/request/clients';
import { getData, getResult } from 'helpers/request';
import {
  IExportMidTidBankParams,
  IExportSposContracts,
  IGetSposContractsParams,
  IGetSposContractsResponse,
  IImplementSposContract,
  IRegisterSposV2Payload,
  ISposContractDetail,
  ISposDevice,
  IUpdateContractAndDevices,
  IUpdateSposContractStatus,
  IUpsertSposDevicePayload,
} from 'interfaces';
import qs from 'qs';

const getListContractSpos = (
  params: IGetSposContractsParams
): Promise<IGetSposContractsResponse> => {
  return bffServiceClient
    .get('/sposContracts', {
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    })
    .then(getData);
};

const exportListMidTidBank = (
  payload: IExportMidTidBankParams
): Promise<{ filePath: string }> => {
  return bffServiceClient.post('/exportMidTidBanks', payload).then(getData);
};

const updateContractStatus = (
  sposContractId: number,
  payload: IUpdateSposContractStatus
) => {
  return bffServiceClient.post(
    `/sposContract/${sposContractId}/updateContractStatus`,
    payload
  );
};

const getSposContract = (
  id: number,
  isGetHistory?: boolean
): Promise<ISposContractDetail> => {
  return bffServiceClient
    .get(`/sposContract/${id}`, { params: { isGetHistory: isGetHistory } })
    .then(getData);
};

const getSposDevices = (
  sposContractId: number
): Promise<{ devices: ISposDevice[] }> => {
  return bffServiceClient
    .get('/sposDevices', {
      params: { sposContractId: sposContractId },
    })
    .then(getData);
};

const getHaveFirstSposContract = (
  merchantId: number
): Promise<{ haveFirstSposContract: boolean }> => {
  return bffServiceClient
    .get(`/haveFirstSposContract/${merchantId}`)
    .then(getData);
};

const registerSposV2 = (
  payload: IRegisterSposV2Payload
): Promise<{ sposContractId: number }> => {
  return bffServiceClient
    .post('/terminalService/spos/v2', payload)
    .then(getData);
};

const upsertSposDevice = (
  payload: IUpsertSposDevicePayload
): Promise<{ id: number }> => {
  return bffServiceClient.post('/sposDevices', payload).then(getData);
};

const implementSposContract = (
  payload: IImplementSposContract
): Promise<{ code: string; message: string }> => {
  return bffServiceClient
    .post('/ticket/implementSposContract', payload)
    .then(getResult);
};

const updateContractAndDevices = (
  payload: IUpdateContractAndDevices,
  sposContractId: number
): Promise<{ sposContractId: number }> => {
  return bffServiceClient
    .post(`/sposContract/${sposContractId}/updateContractAndDevices`, payload)
    .then(getResult);
};

const exportSposContracts = (
  payload: IExportSposContracts
): Promise<{ taskId: string }> => {
  return bffServiceClient
    .post('/sposContracts/request-export', payload)
    .then(getData);
};

const getExportSposContractsStatus = (
  taskId: string
): Promise<{ code: string; message: string; data?: { fileName: string } }> => {
  return bffServiceClient
    .get(`/sposContracts/get-export/${taskId}`)
    .then(getResult);
};

export default {
  getListContractSpos,
  exportListMidTidBank,
  updateContractStatus,
  getSposContract,
  getSposDevices,
  getHaveFirstSposContract,
  registerSposV2,
  upsertSposDevice,
  implementSposContract,
  updateContractAndDevices,
  exportSposContracts,
  getExportSposContractsStatus,
};
